export default __webpack_public_path__ + "static/media/forwardTrend.e7986dc9.svg";